// /app/frontend/src/components/frugal-v2/components/CashflowReportModal.jsx
// Standalone Cash Flow report modal

import React from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import CashflowSection from './reports/CashflowSection';
import { translations } from './reports/reportTranslations';

export default function CashflowReportModal({ isOpen, onClose }) {
  const { i18n } = useTranslation();
  const token = localStorage.getItem('token');
  const lang = i18n.language?.startsWith('es') ? 'es' : 'en';
  const t = translations[lang];

  if (!isOpen) return null;

  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth() + 1;

  const modalContent = (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-2 sm:p-4" data-testid="cashflow-modal">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-2xl max-h-[92vh] bg-slate-900 rounded-2xl border border-white/10 overflow-hidden flex flex-col">
        <div className="flex items-center justify-between p-3 sm:p-4 border-b border-white/10">
          <h2 className="text-lg font-semibold text-white">{t.cashflowTitle}</h2>
          <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-lg" data-testid="cashflow-close-btn">
            <X className="w-5 h-5 text-slate-400" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-3 sm:p-4">
          <CashflowSection token={token} year={year} month={month} t={t} lang={lang} />
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
}
